import React from 'react'
import * as UIcons from '@iconscout/react-unicons'

export default function ReviewDetailDrawer({ review, onClose }) {
  const fields = [
    { label: 'Contact name', value: review.contactName },
    { label: 'Email', value: review.email },
    { label: 'Contact Type', value: review.contactType },
    { label: 'Phone number', value: review.phone }
  ]

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="absolute inset-0 bg-dark-blue bg-opacity-40" onClick={onClose} />

      <div className="relative w-full max-w-[420px] h-full bg-white shadow-xl flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-border-lines">
          <p className="text-base font-semibold text-dark-blue">Review Detail</p>
          <button type="button" onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-background">
            <UIcons.UilTimes size={18} className="text-secondary" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          {
            fields.map((field) => (
              <div key={field.label} className="py-3 border-b border-border-lines">
                <p className="text-xs text-secondary mb-1">{field.label}</p>
                <p className="text-sm text-dark-blue">{field.value}</p>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}
